import { BackgroundRuns } from 'components/BackgroundRuns'
import { AccountType } from 'config/user.type.constants'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { BorrowerHeader, Footer, Header, VendorHeader } from 'stories/layouts'
import { FloaterTabs } from 'stories/layouts/FloaterTabs'
import { InvestorHeader } from 'stories/layouts/InvestorHeader'
import { ParticipantHeader } from 'stories/layouts/ParticipantHeader'
import { PinnedNotesBanner } from 'stories/layouts/PinnedNotes'
import { useQueryRecord } from 'utils'

export const BaseLayout = (props: any) => {
  const { children } = props
  const auth = useSelector((state: any) => state.auth)
  const { isBorrower, isInvestor, isParticipant, accountType } = auth.profile || {}
  const { pathname } = useLocation()
  const isEmbed = pathname.startsWith('/embed/')

  const queryRecords: any = useQueryRecord()
  const { noHeader = false } = queryRecords
  const hideChrome = isEmbed || noHeader !== false

  const renderHeader = () => {
    if (isBorrower) return <BorrowerHeader />
    // The investor portal signs in as the directory record (`isParticipant`). The older investor
    // login still carries `isInvestor` and its own menu.
    if (isParticipant) return <ParticipantHeader />
    if (isInvestor) return <InvestorHeader />
    if (accountType === AccountType.VENDOR) return <VendorHeader />
    return <Header />
  }

  return (
    <div className="app-shell relative overflow-x-clip">
      <DndProvider backend={HTML5Backend}>
        <div className={`relative lg:w-full flex flex-col min-h-screen`}>
          {hideChrome ? null : renderHeader()}
          <main className="flex-1 w-full relative mx-auto main">
            {isEmbed ? null : <PinnedNotesBanner />}
            {children}
            {!isEmbed && !isBorrower && !isInvestor && !isParticipant && accountType !== AccountType.VENDOR && (
              <FloaterTabs />
            )}
            {/* Runs sent to the background outlive the screen that started them, so the tray that
                reports them lives here rather than on the reports page. Staff only: borrowers,
                investors and vendors have no screen that can start one. */}
            {!isEmbed && !isBorrower && !isInvestor && !isParticipant && accountType !== AccountType.VENDOR ? (
              <BackgroundRuns />
            ) : null}
          </main>
          {hideChrome ? null : <Footer />}
        </div>
      </DndProvider>
    </div>
  )
}
